type GetThumbnail = (file: Blob) => Promise<File>;

export const getThumbnail: GetThumbnail = (file) => {
    let objectUrl: string;
    return new Promise<File>((resolve) => {
        const video = document.createElement('video');
        objectUrl = URL.createObjectURL(file);

        video.src = objectUrl;
        video.currentTime = 0.1;
        video.controls = true;

        video.addEventListener('loadeddata', () => {
            if (video.videoWidth > 0 && video.videoHeight > 0) {
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const context = canvas.getContext('2d');

                if (context) {
                    context.drawImage(video, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob((blob) => {
                        if (blob) {
                            const thumbnailFile = new File([blob], 'thumbnail.jpg', {
                                type: blob.type,
                            });
                            resolve(thumbnailFile);
                        }
                    }, 'image/jpeg');
                }
            }
        });
    }).finally(() => {
        if (objectUrl) {
            URL.revokeObjectURL(objectUrl);
        }
    });
};
